import $ from "jquery";

export const accordion = () => {
  const accordion = $(".js-accordion");

  const accordionItems = accordion.find(".js-accordion-trigger");
  accordionItems.each(function () {
    const accordionItem = $(this);
    const accordionContent = accordionItem.find(".js-accordion-content").length
      ? accordionItem.find(".js-accordion-content")
      : accordionItem.next();

    accordionItem.on("click", function () {
      accordionItem.toggleClass("is-open");
      accordionContent.slideToggle(300);
    });
  });
};
